export default {
  states: {
    success: 'Thành công!',
    error: 'Lỗi!',
  },
}
